import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { directMailAPI } from "api/Interactions/DirectMailAPI";
import { DirectMail } from "api/Interactions/InteractionsInterfaces";
import DirectMailEmptyPage from "./DirectMailEmptyPage";
import GenericDetailPage from "components/Interactions/GenericDetailPage";

interface DirectMailDetailProps {
  directMailId: number;
  onClose?: () => void;
}

const DirectMailDetail: React.FC<DirectMailDetailProps> = ({
  directMailId,
  onClose,
}) => {
  const theme = useTheme();
  const [record, setRecord] = useState<DirectMail | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const numberOfMail = (record as any)?.people?.length || 0;
  const costPerMail = 0.05;

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await directMailAPI.getById(directMailId);
        setRecord(data as DirectMail);
      } catch (err) {
        console.error("Error loading direct mail:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [directMailId]);

  const handleUpdate = async (id: number, field: keyof DirectMail, value: any) => {
    if (typeof id !== "number") return;
    try {
      setSaving(true);
      const updated = await directMailAPI.updateField(id, String(field), value);
      setRecord(updated as DirectMail);
    } catch (err) {
      console.error(`Error updating field "${String(field)}":`, err);
    } finally {
      setSaving(false);
    }
  };

  const handleToggleFulfilled = async () => {
    if (!record) return;
    await handleUpdate(
      record.id,
      "pathways_fulfilled" as keyof DirectMail,
      !(record as any).pathways_fulfilled
    );
  };

  if (loading) return null;
  if (!record) return <DirectMailEmptyPage />;

  return (
    <GenericDetailPage
      record={record}
      loading={loading}
      saving={saving}
      onClose={onClose}
      onUpdate={handleUpdate}
      onToggleFulfilled={handleToggleFulfilled}
      fulfilled={!!(record as any).pathways_fulfilled}
      fulfillmentDetailsLabel="Direct Mail"
      numberOfItems={numberOfMail}
      costPerItem={costPerMail}
      fulfilledByPathwaysAvailable={false}
      registration={false}
      showSaveButton
      saveButtonColor={theme.custom.modules.interactions.primary.dark}
      contentDetailFields={[
        {
          label: "File",
          value: (record as any).file,
          field: "file",
          type: "file",
          accept: "image/*,.pdf",
        },
        {
          label: "Size",
          value: (record as any).size,
          field: "size",
          type: "select",
          options: [
            { label: "A6", value: "A6" },
            { label: "A5", value: "A5" },
            { label: "A4", value: "A4" },
          ],
        },
        {
          label: "Postage Type",
          value: (record as any).postage_type,
          field: "postage_type",
          type: "select",
          options: [
            { label: "First Class", value: "first_class" },
            { label: "Second Class", value: "second_class" },
          ],
        },
        
      ]}
    />
  );
};

export default DirectMailDetail;
